module.exports = __webpack_public_path__ + "img/bg-frame-en.6a4fcf41.png";